import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SetupItems } from '../models/setupItems';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends ServiceBase {

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }
  // fetchCategory

  public fetchCategory(artTypeId: string | null= null): Observable<SetupItems[]> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/Category';
    const method: string = '/fetch';
    var url = environment.BASE_API_PATH + api + method;
    if (artTypeId) {
      url += '/' + artTypeId;
    }
    return this.http.get<SetupItems[]>(url, httpOptions);
  }

  public saveCategory(category: SetupItems): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/Category';
    const method: string = '/save';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, category, httpOptions);
  }

  public deleteCategory(categoryId: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/Category';
    const method: string = '/deleteCategory/';
    const url: string = environment.BASE_API_PATH + api + method + categoryId;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public excludeCategory(Id: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Category';
    const method: string = '/exclude/';
    const url: string = environment.BASE_API_PATH + api + method + Id;
    return this.http.post<ResponseObject>(url,{}, httpOptions);
  }
}
